// Browser substitute for ./server, wired via the package.json `browser` field.
// Keeps every named export resolvable in client bundles (Turbopack hard-errors
// on imports of names a false-mapped module lacks; webpack only warned).
export * from './server/forceBucketing'

const serverOnly = (name: string) => () => {
  throw new Error(
    `@mc/next-growthbook: ${name} is server-only and cannot run in the browser`,
  )
}

export const getGrowthBookFlags: typeof import('./server').getGrowthBookFlags =
  serverOnly('getGrowthBookFlags')

export const getBucket: typeof import('./server').getBucket =
  serverOnly('getBucket')

export const getExperimentVariables: typeof import('./server').getExperimentVariables =
  serverOnly('getExperimentVariables')

export const getFeatureFlip: typeof import('./server').getFeatureFlip =
  serverOnly('getFeatureFlip')

// Compile-time parity guard: errors when ./server gains an export this stub lacks.
export const _serverExportParity: Omit<
  typeof import('./server'),
  keyof typeof import('./server.browser')
> = {}
